import * as Sentry from "@sentry/browser";
import { getHostInfo } from "./helper";

const allowedHostsForLogs = ['tdn', 'canaluat', 'dev', 'qaautomation', 'truckerrobles'];

const reportUsageMessage = (message: string) => {
    Sentry.captureMessage(message, "info");
}

const reportException = (error: any) => {
    Sentry.captureException(error)
}

const tc_log = (message: any, object: any = {}, host: string = '') => {
    const currentSubdomain = getHostInfo().subdomain;
    const currentHost = getHostInfo().fullHostname;

    if (message === null || message === undefined) {
        return;
    }

    if (getHostInfo().isLocalhost 
        || allowedHostsForLogs.includes(currentSubdomain ?? '') 
        || (host !== null && host !== undefined && host !== '' && host === currentHost)) {
        if (object) {
            console.log(message, object);
        } else {
            console.log(message);
        }
    }
}

export {
    reportUsageMessage,
    reportException,
    tc_log
}